interface Props {
  title: string;
}
export function AdminTitle({ title }: Props) {
  return <h1 className="page-header">{title}</h1>;
}
